import { ClassNames } from "@emotion/react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import AiChatPanel from "components/ai_chat/AiChatPanel";
import { TextArea } from "components/form_components/Inputs";
import Button from "components/ui/button/Button";
import Card from "components/ui/card/Card";

type Props = {
  resourceId: string;
  resourceName?: string;
  bidQuestion: string;
};

export default function AiAssistant({ resourceId, resourceName, bidQuestion }: Props) {
  return (
    <AiAssistantContainer>
      <AiChatPanel
        resourceId={resourceId}
        resourceName={resourceName || ""}
        resourceType="BID_WRITING_QA"
        additionalContext={bidQuestion}
        suggestedQuestionsLayout="vertical"
        uiText={{
          title: "",
          subtitle: "",
        }}
        showHistory={false}
        showDisclaimer={false}
        userInitialsType="small"
        mainContainerPadding="12px"
        chatThreadContainerPadding="48px 16px 0 4px"
        renderInput={({ control, formState }, handleQuestionSubmit, isLoading) => {
          return (
            <InputContainer>
              <Flex column gap={16}>
                <ClassNames>
                  {({ css }) => {
                    return (
                      <TextArea
                        autoSize={{ minRows: 3, maxRows: 3 }}
                        autoFocus
                        name="userInputQuestion"
                        label={""}
                        control={control}
                        className={css({
                          width: "100%",
                          borderRadius: 4,
                        })}
                        placeholder="Ask anything"
                        disabled={isLoading}
                        aria-label="Ask a question"
                        showErrors={false}
                        onPressEnter={(e) => {
                          if (e.shiftKey) {
                            // Allow newline when Shift + Enter is pressed
                            return;
                          }
                          // Prevent newline and trigger submission on Enter without Shift
                          e.preventDefault();
                          e.stopPropagation();
                          void handleQuestionSubmit();
                        }}
                      />
                    );
                  }}
                </ClassNames>
                <Flex justifyContent="space-between" alignItems="center">
                  <Button buttonStyle="inverse" icon="globe01">
                    Sources
                  </Button>
                  <Flex gap={8}>
                    <Button buttonStyle="inverse" icon="attachment01" />
                    <Button
                      buttonType="primary"
                      disabled={Boolean(formState.errors.userInputQuestion)}
                      type="submit"
                      aria-label="Ask question"
                      icon="arrowUp"
                      iconProps={{ size: 16 }}
                      style={{ borderRadius: 4 }}
                    />
                  </Flex>
                </Flex>
              </Flex>
            </InputContainer>
          );
        }}
      />
    </AiAssistantContainer>
  );
}

const InputContainer = styled(Card)({
  boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.12)",
});

const AiAssistantContainer = styled.div({
  height: "100%",
  paddingBottom: 24,
});
